import { InsightDrawer } from "./InsightDrawer";
import { LabelLiftData, useSafeLabelLiftQuery } from "./useSafeLabelLiftQuery";
import { Insight } from "../InsightsTable/InsightsTable";
import { KPI } from "../InsightsTable/__generated__/InsightsTableQuery.graphql";
import { CurrencyType } from "../TopPerformingAds/__generated__/TopPerformingAdsQuery.graphql";


interface InsightDrawerWithQueryProps {
  insight: Insight;
  kpi: KPI | null;
  kpiDisplay: string;
  currencyType: CurrencyType;
  insightsGraphEnabled: boolean;
  metricInsightGraphEnabled?: boolean;
  labelLiftCache: Record<string, LabelLiftData[]>;
  setLabelLiftCache: (cache: Record<string, LabelLiftData[]>) => void;
  onCloseDrawer: () => void;
  onShareInsight?: () => void;
}

export const InsightDrawerWithQuery = ({
  insight,
  kpi,
  kpiDisplay,
  currencyType,
  insightsGraphEnabled,
  metricInsightGraphEnabled = false,
  labelLiftCache,
  setLabelLiftCache,
  onCloseDrawer,
  onShareInsight
}: InsightDrawerWithQueryProps) => {
  const res = useSafeLabelLiftQuery({
    insight,
    kpi,
    insightsGraphEnabled,
    labelLiftCache,
    setLabelLiftCache,
  });

  return (
    <InsightDrawer
      insight={insight}
      kpi={kpi}
      kpiDisplay={kpiDisplay}
      currencyType={currencyType}
      insightsGraphEnabled={insightsGraphEnabled}
      metricInsightGraphEnabled={metricInsightGraphEnabled}
      res={res.labelLiftData ? [...res.labelLiftData] : undefined}
      onCloseDrawer={onCloseDrawer}
      onShareInsight={onShareInsight}
    />
  );
};
